import React from 'react';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { FileExcel } from 'styled-icons/bootstrap';

function ExportExcel(props) {
  const { studentsDataSet } = props;

  const [data, setData] = React.useState({});

  const exporter = React.useRef();

  const exportExcelFunction = () => {
    if (exporter.current) {
      exporter.current.save();
    }
  };

  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  const formatDate = (date) => {
    const event = new Date(date);
    if (!isValidDate(event)) return 'Sin fecha registrada';
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = event.toLocaleDateString('es-ES', options);
    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  };

  React.useEffect(() => {
    const temp = (studentsDataSet || []).reduce((acc, element) => {
      if (element) {
        const data = { ...element };
        data.career = element.career === '-----' ? 'No definido' : element.career;
        data.campusSegment = element.campusSegment
          ? element.campusSegment
          : element.platformCampus
          ? element.platformCampus
          : 'No definido';
        data.phoneNumber = element.phoneNumber === '-----' ? 'No definido' : element.phoneNumber;
        data.existCv = element.cvData || element.existCv ? 'Si' : 'No';
        data.lastLogin = formatDate(element.lastLogin);
        data.lastApply = formatDate(element.lastApply);
        acc.push(data);
      }
      return acc;
    }, []);
    setData(temp);
  }, [studentsDataSet]);

  return (
    <>
      <button
        type="button"
        className="k-button k-primary"
        onClick={exportExcelFunction}
        style={{ background: '   #0f3f44', width: '100%', border: '#0f3f44' }}>
        <FileExcel size={20} color="#fff" />
        Exportar a Excel
      </button>
      <ExcelExport data={data} fileName="Perfil-estudiante.xlsx" ref={exporter}>
        <ExcelExportColumn title="ID o Matricula" field="scholarID" />
        <ExcelExportColumn title="Nombre" field="names" />
        <ExcelExportColumn title="Apellidos" field="lastNames" />
        <ExcelExportColumn title="Correo electrónico" field="email" />
        <ExcelExportColumn title="Tipo de usuario" field="userType" />
        <ExcelExportColumn title="Pregunta de validacion" field="currentQuestion" />
        <ExcelExportColumn title="Respuesta" field="question" />
        <ExcelExportColumn title="Carrera" field="career" />
        <ExcelExportColumn title="Teléfono" field="phoneNumber" />
        <ExcelExportColumn title="Campus / Sede" field="campusSegment" />
        <ExcelExportColumn title="Ultima fecha de conexión" field="lastLogin" />
        <ExcelExportColumn title="Ultima fecha de aplicación" field="lastApply" />
        <ExcelExportColumn title="Cantidad de postulaciones" field="applyCount" />
        <ExcelExportColumn title="CV agregado" field="existCv" />
      </ExcelExport>
    </>
  );
}

export default ExportExcel;
